<script setup lang="ts">
import { provide, useTemplateRef } from 'vue';
import VPConfirmationDialog from './VPConfirmationDialog.vue';
import VPTextInputDialog from './VPTextInputDialog.vue';
import { useConfirmationDialogHost } from '../composables/confirmationDialog';

// Also serves `openTextInputDialog()`, so a text request never shares the screen with a confirmation.
const { current, settle, settleTextInput } = useConfirmationDialogHost();

// Its own target, so the dialog stays visible wherever the host is mounted — including outside a hidden pane.
const target = useTemplateRef<HTMLElement>('target');
provide('vpModalTeleportTarget', target);
</script>

<template>
  <div ref="target" />
  <template v-if="current && target">
    <VPConfirmationDialog
      v-if="current.kind === 'confirmation'"
      :key="current.id"
      v-bind="current.options"
      show
      :z-index-level="3"
      @close="(outcome, failure) => settle(current!.id, outcome, failure)"
    />
    <VPTextInputDialog
      v-else
      :key="current.id"
      v-bind="current.options"
      show
      :z-index-level="3"
      @close="outcome => settleTextInput(current!.id, outcome)"
    />
  </template>
</template>
